import { guides } from "@/mocks/verify";

export default function Guide() {
  return (
    <section id="guide" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            How We Verify
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[2rem]">
            分辨真假的四步法
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            与其被动等待反转，不如掌握判断框架。这四步来自我们每天核验传闻的通用流程，你也可以自己用。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guides.map((g) => (
            <article
              key={g.no}
              className="group relative flex flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <span className="pointer-events-none absolute right-5 top-5 font-heading text-3xl font-black text-background-200 transition-colors group-hover:text-primary-200">
                {g.no}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-2xl text-primary-700">
                <i className={g.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-2.5 text-[13px] leading-relaxed text-foreground-600">{g.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}